const actions = {
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID: 'FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID',
  FETCHING_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID: 'FETCHING_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID',
  FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_SUCCESS:
    'FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_SUCCESS',
  FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_FAILED:
    'FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID_FAILED',

  FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID:
    'FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID',
  FETCHING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID:
    'FETCHING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID',
  FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_SUCCESS:
    'FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_SUCCESS',
  FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_FAILED:
    'FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID_FAILED',

  FETCH_SETTLEMENT_REPORT_HISTORY: 'FETCH_SETTLEMENT_REPORT_HISTORY',
  LOADING_MORE_SETTLEMENT_REPORT_HISTORY: 'LOADING_MORE_SETTLEMENT_REPORT_HISTORY',
  FETCHING_SETTLEMENT_REPORT_HISTORY: 'FETCHING_SETTLEMENT_REPORT_HISTORY',
  FETCH_SETTLEMENT_REPORT_HISTORY_SUCCESS: 'FETCH_SETTLEMENT_REPORT_HISTORY_SUCCESS',
  FETCH_SETTLEMENT_REPORT_HISTORY_FAILED: 'FETCH_SETTLEMENT_REPORT_HISTORY_FAILED',
  RESET_SETTLEMENT_REPORT_HISTORY: 'RESET_SETTLEMENT_REPORT_HISTORY',

  GENERATE_MERCHANT_SETTLEMENT_REPORT: 'GENERATE_MERCHANT_SETTLEMENT_REPORT',
  GENERATING_MERCHANT_SETTLEMENT_REPORT: 'GENERATING_MERCHANT_SETTLEMENT_REPORT',
  GENERATE_MERCHANT_SETTLEMENT_REPORT_SUCCESS: 'GENERATE_MERCHANT_SETTLEMENT_REPORT_SUCCESS',
  GENERATE_MERCHANT_SETTLEMENT_REPORT_FAILED: 'GENERATE_MERCHANT_SETTLEMENT_REPORT_FAILED',

  FETCH_SETTLEMENT_SUBMISSIONS: 'FETCH_SETTLEMENT_SUBMISSIONS',
  LOADING_MORE_SETTLEMENT_SUBMISSIONS: 'LOADING_MORE_SETTLEMENT_SUBMISSIONS',
  FETCHING_SETTLEMENT_SUBMISSIONS: 'FETCHING_SETTLEMENT_SUBMISSIONS',
  FETCH_SETTLEMENT_SUBMISSIONS_SUCCESS: 'FETCH_SETTLEMENT_SUBMISSIONS_SUCCESS',
  FETCH_SETTLEMENT_SUBMISSIONS_FAILED: 'FETCH_SETTLEMENT_SUBMISSIONS_FAILED',
  RESET_SETTLEMENT_SUBMISSIONS: 'RESET_SETTLEMENT_SUBMISSIONS',

  FETCH_SETTLEMENT_SUBMISSION: 'FETCH_SETTLEMENT_SUBMISSION',
  LOADING_MORE_SETTLEMENT_SUBMISSION: 'LOADING_MORE_SETTLEMENT_SUBMISSION',
  FETCHING_SETTLEMENT_SUBMISSION: 'FETCHING_SETTLEMENT_SUBMISSION',
  FETCH_SETTLEMENT_SUBMISSION_SUCCESS: 'FETCH_SETTLEMENT_SUBMISSION_SUCCESS',
  FETCH_SETTLEMENT_SUBMISSION_FAILED: 'FETCH_SETTLEMENT_SUBMISSION_FAILED',
  RESET_SETTLEMENT_SUBMISSION: 'RESET_SETTLEMENT_SUBMISSION',

  DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT: 'DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT',
  DOWNLOADING_SETTLEMENT_SUBMISSION_DOCUMENT: 'DOWNLOADING_SETTLEMENT_SUBMISSION_DOCUMENT',
  DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_SUCCESS:
    'DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_SUCCESS',
  DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_FAILED: 'DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT_FAILED',

  APPROVE_SETTLEMENT_SUBMISSION: 'APPROVE_SETTLEMENT_SUBMISSION',
  APPROVING_SETTLEMENT_SUBMISSION: 'APPROVING_SETTLEMENT_SUBMISSION',
  APPROVE_SETTLEMENT_SUBMISSION_SUCCESS: 'APPROVE_SETTLEMENT_SUBMISSION_SUCCESS',
  APPROVE_SETTLEMENT_SUBMISSION_FAILED: 'APPROVE_SETTLEMENT_SUBMISSION_FAILED',

  ENDORSE_SETTLEMENT_SUBMISSION: 'ENDORSE_SETTLEMENT_SUBMISSION',
  ENDORSING_SETTLEMENT_SUBMISSION: 'ENDORSING_SETTLEMENT_SUBMISSION',
  ENDORSE_SETTLEMENT_SUBMISSION_SUCCESS: 'ENDORSE_SETTLEMENT_SUBMISSION_SUCCESS',
  ENDORSE_SETTLEMENT_SUBMISSION_FAILED: 'ENDORSE_SETTLEMENT_SUBMISSION_FAILED',

  REJECT_SETTLEMENT_SUBMISSION: 'REJECT_SETTLEMENT_SUBMISSION',
  REJECTING_SETTLEMENT_SUBMISSION: 'REJECTING_SETTLEMENT_SUBMISSION',
  REJECT_SETTLEMENT_SUBMISSION_SUCCESS: 'REJECT_SETTLEMENT_SUBMISSION_SUCCESS',
  REJECT_SETTLEMENT_SUBMISSION_FAILED: 'REJECT_SETTLEMENT_SUBMISSION_FAILED',

  APPROVE_SETTLEMENT_SUBMISSIONS: 'APPROVE_SETTLEMENT_SUBMISSIONS',
  APPROVING_SETTLEMENT_SUBMISSIONS: 'APPROVING_SETTLEMENT_SUBMISSIONS',
  APPROVE_SETTLEMENT_SUBMISSIONS_SUCCESS: 'APPROVE_SETTLEMENT_SUBMISSIONS_SUCCESS',
  APPROVE_SETTLEMENT_SUBMISSIONS_FAILED: 'APPROVE_SETTLEMENT_SUBMISSIONS_FAILED',

  ENDORSE_SETTLEMENT_SUBMISSIONS: 'ENDORSE_SETTLEMENT_SUBMISSIONS',
  ENDORSING_SETTLEMENT_SUBMISSIONS: 'ENDORSING_SETTLEMENT_SUBMISSIONS',
  ENDORSE_SETTLEMENT_SUBMISSIONS_SUCCESS: 'ENDORSE_SETTLEMENT_SUBMISSIONS_SUCCESS',
  ENDORSE_SETTLEMENT_SUBMISSIONS_FAILED: 'ENDORSE_SETTLEMENT_SUBMISSIONS_FAILED',

  REJECT_SETTLEMENT_SUBMISSIONS: 'REJECT_SETTLEMENT_SUBMISSIONS',
  REJECTING_SETTLEMENT_SUBMISSIONS: 'REJECTING_SETTLEMENT_SUBMISSIONS',
  REJECT_SETTLEMENT_SUBMISSIONS_SUCCESS: 'REJECT_SETTLEMENT_SUBMISSIONS_SUCCESS',
  REJECT_SETTLEMENT_SUBMISSIONS_FAILED: 'REJECT_SETTLEMENT_SUBMISSIONS_FAILED',

  GENERATE_CONSOLIDATED_SETTLEMENT_REPORT: 'GENERATE_CONSOLIDATED_SETTLEMENT_REPORT',
  GENERATING_CONSOLIDATED_SETTLEMENT_REPORT: 'GENERATING_CONSOLIDATED_SETTLEMENT_REPORT',
  GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS:
    'GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS',
  GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_FAILED: 'GENERATE_CONSOLIDATED_SETTLEMENT_REPORT_FAILED',

  FETCH_CONSOLIDATED_SETTLEMENT_REPORTS: 'FETCH_CONSOLIDATED_SETTLEMENT_REPORTS',
  FETCHING_CONSOLIDATED_SETTLEMENT_REPORTS: 'FETCHING_CONSOLIDATED_SETTLEMENT_REPORTS',
  FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_SUCCESS: 'FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_SUCCESS',
  FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_FAILED: 'FETCH_CONSOLIDATED_SETTLEMENT_REPORTS_FAILED',

  DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT: 'DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT',
  DOWNLOADING_CONSOLIDATED_SETTLEMENT_REPORT: 'DOWNLOADING_CONSOLIDATED_SETTLEMENT_REPORT',
  DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS:
    'DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_SUCCESS',
  DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_FAILED: 'DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT_FAILED',

  GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  GENERATING_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'GENERATING_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  DOWNLOADING_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOADING_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS: 'FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS',
  FETCHING_MERCHANT_SETTLEMENT_SUMMARY_REPORTS: 'FETCHING_MERCHANT_SETTLEMENT_SUMMARY_REPORTS',
  FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_SUCCESS:
    'FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_SUCCESS',
  FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_FAILED:
    'FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS_FAILED',

  APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  APPROVING_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'APPROVING_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
    'REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  REQUESTING_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT:
    'REQUESTING_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  REJECTING_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'REJECTING_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    'REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_SUCCESS',
  REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED:
    'REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT_FAILED',

  SEND_EMAIL_VALIDATION_REPORT: 'SEND_EMAIL_VALIDATION_REPORT',
  SENDING_EMAIL_VALIDATION_REPORT: 'SENDING_EMAIL_VALIDATION_REPORT',
  SEND_EMAIL_VALIDATION_REPORT_SUCCESS: 'SEND_EMAIL_VALIDATION_REPORT_SUCCESS',
  SEND_EMAIL_VALIDATION_REPORT_FAILED: 'SEND_EMAIL_VALIDATION_REPORT_FAILED',

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  fetchSRFTransactionDetailsRequestByID: payload => {
    return {
      type: actions.FETCH_SRF_TRANSACTION_DETAILS_REQUEST_BY_ID,
      payload
    };
  },

  fetchMerchantSettlementPaymentChannelsById: payload => {
    return {
      type: actions.FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID,
      payload
    };
  },

  fetchSettlementReportHistory: (payload, pagination) => ({
    type: actions.FETCH_SETTLEMENT_REPORT_HISTORY,
    payload,
    pagination
  }),

  generateMerchantSettlementReport: payload => ({
    type: actions.GENERATE_MERCHANT_SETTLEMENT_REPORT,
    payload
  }),

  fetchSettlementSubmissions: payload => ({
    type: actions.FETCH_SETTLEMENT_SUBMISSIONS,
    payload
  }),

  fetchSettlementSubmission: payload => ({
    type: actions.FETCH_SETTLEMENT_SUBMISSION,
    payload
  }),

  downloadSettlementSubmissionDocument: id => ({
    type: actions.DOWNLOAD_SETTLEMENT_SUBMISSION_DOCUMENT,
    id
  }),

  endorseSettlementSubmissions: (urls, payload) => ({
    type: actions.ENDORSE_SETTLEMENT_SUBMISSIONS,
    urls,
    payload
  }),

  approveSettlementSubmissions: (urls, payload) => ({
    type: actions.APPROVE_SETTLEMENT_SUBMISSIONS,
    urls,
    payload
  }),

  rejectSettlementSubmissions: payload => ({
    type: actions.REJECT_SETTLEMENT_SUBMISSIONS,
    payload
  }),

  endorseSettlementSubmission: (urls, payload) => ({
    type: actions.ENDORSE_SETTLEMENT_SUBMISSION,
    urls,
    payload
  }),

  approveSettlementSubmission: (urls, payload) => ({
    type: actions.APPROVE_SETTLEMENT_SUBMISSION,
    urls,
    payload
  }),

  rejectSettlementSubmission: payload => ({
    type: actions.REJECT_SETTLEMENT_SUBMISSION,
    payload
  }),

  sendEmailValidationReport: payload => ({
    type: actions.SEND_EMAIL_VALIDATION_REPORT,
    payload
  }),

  generateConsolidatedSettlementReport: payload => ({
    type: actions.GENERATE_CONSOLIDATED_SETTLEMENT_REPORT,
    payload
  }),

  fetchConsolidatedSettlementReports: payload => ({
    type: actions.FETCH_CONSOLIDATED_SETTLEMENT_REPORTS,
    payload
  }),

  downloadConsolidatedSettlementReport: id => ({
    type: actions.DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT,
    id
  }),

  generateMerchantSettlementSummaryReport: payload => ({
    type: actions.GENERATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT,
    payload
  }),

  downloadMerchantSettlementSummaryReport: id => ({
    type: actions.DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT,
    id
  }),

  fetchMerchantSettlementSummaryReports: payload => ({
    type: actions.FETCH_MERCHANT_SETTLEMENT_SUMMARY_REPORTS,
    payload
  }),

  requestReviewMerchantSettlementSummaryReport: (urls, payload) => ({
    type: actions.REQUEST_REVIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT,
    urls,
    payload
  }),

  rejectMerchantSettlementSummaryReport: payload => ({
    type: actions.REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT,
    payload
  }),

  approveMerchantSettlementSummaryReport: (urls, payload) => ({
    type: actions.APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT,
    urls,
    payload
  })
};

export default actions;
